import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { providePrimeNG } from 'primeng/config';
import { MsalGuardConfigurationFactory, MSALInstanceFactory } from '@/app/lib/auth/auth.util';
import { routes } from '@/app/app.routes';
import { authInterceptor, errorInterceptor } from '@/app/lib/interceptors';
import { primeNGConfig } from '@/app/lib/theme';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MsalGuardConfigurationFactory,
    },
    provideAnimationsAsync(),
    providePrimeNG(primeNGConfig),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideZonelessChangeDetection(),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
